import { Card, Layout, Typography } from 'antd';
import AppHeader from 'containers/AppLayout/AppHeader';
import React, { useEffect, useState } from 'react';
import './SposErrorTracer.scss';
import { t } from 'helpers/i18n';
import firebase from 'firebase';
import { runAsync } from 'util/async';
import { useParams } from 'react-router-dom';
import ReactJson from 'react-json-view';
import { useDispatch } from 'react-redux';
import { showError, showLoading, showSuccess } from 'store/popup/actions';

const ENCODED_CONFIG =
  'eyJhcGlLZXkiOiJBSXphU3lEZE9QSzFfZTVhZXU2Q3hjYzZjVThhb2pidllEQ3pDX3MiLCJhdXRoRG9tYWluIjoicG9zLnBob25ndnUudm4iLCJkYXRhYmFzZVVSTCI6Imh0dHBzOi8vbmhhbi12aWVuLXBob25nLXZ1LmZpcmViYXNlaW8uY29tIiwicHJvamVjdElkIjoibmhhbi12aWVuLXBob25nLXZ1Iiwic3RvcmFnZUJ1Y2tldCI6Im5oYW4tdmllbi1waG9uZy12dS5hcHBzcG90LmNvbSJ9';

firebase.initializeApp(JSON.parse(window.atob(ENCODED_CONFIG)));

interface ErrorTraceEntry {
  request: string;
  responseBody: string;
  responseCode: string;
  time: string;
  url: string;
}

interface DisplayErrorTraceEntry {
  request: {
    time: string;
    url: string;
    request: object;
  };
  response: {
    responseCode: string;
    responseBody: string;
  };
}

const SposErrorTracer: React.FC = () => {
  const dispatch = useDispatch();
  const params = useParams<{ traceCode: string }>();
  const [traceContent, setTraceContent] = useState<DisplayErrorTraceEntry>();

  useEffect(() => {
    runAsync(async () => {
      dispatch(showLoading());
      try {
        const snapshot = await firebase
          .database()
          .ref(`trace/error/${params.traceCode}`)
          .once('value');
        const raw = snapshot.toJSON() as ErrorTraceEntry;
        setTraceContent({
          request: {
            time: raw.time,
            url: raw.url,
            request: safelyParseJson(raw.request),
          },
          response: {
            responseCode: safelyParseJson(raw.responseCode),
            responseBody: safelyParseJson(raw.responseBody),
          },
        });
        dispatch(showSuccess());
      } catch (e) {
        dispatch(showError((e as Error).message));
      }
    });
  }, [params, setTraceContent, dispatch]);

  return (
    <Layout className="app-layout">
      <AppHeader>
        <Typography.Title className="home-title">
          {t('SposErrorTracerTool')}
        </Typography.Title>
      </AppHeader>
      <div className="app-header-placeholder" />
      {traceContent && (
        <div className="tool-spos-error-tracer-container">
          <Card
            title="Request"
            bordered={false}
            style={{ flex: 1, marginRight: '8px' }}
          >
            <ReactJson
              src={traceContent.request}
              name={null}
              iconStyle="circle"
              displayDataTypes={false}
              displayObjectSize={false}
              collapseStringsAfterLength={50}
              enableClipboard={true}
            />
          </Card>
          <Card
            title="Response"
            bordered={false}
            style={{ flex: 1, marginLeft: '8px' }}
          >
            <ReactJson
              src={traceContent.response}
              name={null}
              iconStyle="circle"
              displayDataTypes={false}
              displayObjectSize={false}
              collapseStringsAfterLength={50}
              enableClipboard={true}
            />
          </Card>
        </div>
      )}
    </Layout>
  );
};

export default SposErrorTracer;

function safelyParseJson(source: string): any {
  try {
    return JSON.parse(source);
  } catch (error) {
    return source;
  }
}
